import $ from "jquery";

function get_first_selected_file(files) {
  return Array.isArray(files) || typeof files?.length === "number"
    ? Reflect.get(files, 0) || null
    : null;
}

export default {
  computed: {
    active_create_section() {
      return Reflect.get(this.create_job_sections, this.create_active_section_index) || null;
    },
    active_view_section() {
      return Reflect.get(this.view_job_sections, this.view_active_section_index) || null;
    },
    is_view_preview() {
      return this.view_mode === "preview";
    },
    is_view_edit() {
      return this.view_mode === "edit";
    },
    is_view_split() {
      return this.view_mode === "split";
    },
    should_show_preview_panel() {
      return this.is_view_preview || this.is_view_split;
    },
    should_show_editor_panel() {
      return this.is_view_edit || this.is_view_split;
    },
    preview_title_parts() {
      return this.split_job_title(this.view_job_title);
    },
    preview_meta_items() {
      return this.extract_preview_meta(this.view_job_sections);
    },
    parsed_sections() {
      return [
        { key: "meta", label: "A. Job Information", required: true },
        { key: "job_purpose", label: "B. Job Purpose", required: true },
        { key: "main_functions", label: "C. Main Functions", required: true },
        { key: "responsibilities", label: "D. Responsibilities", required: true },
        { key: "outputs_profile", label: "E. Outputs Profile", required: true },
        { key: "competencies", label: "F. Competencies", required: true },
        { key: "career_pathing", label: "G. Career Pathing", required: false },
        { key: "amendments", label: "H. Amendments", required: false },
        { key: "performance_agreement", label: "I. Performance Agreement", required: false },
        { key: "signatories", label: "J. Signatories", required: true },
      ];
    },
    parsed_completion_percent() {
      if (!this.parsed_document) return 0;
      const required = this.parsed_sections.filter((section) => section.required);
      const completed = required.filter((section) => this.section_has_content(section.key));
      return Math.round((completed.length / required.length) * 100);
    },
    parsed_is_ready() {
      return !!this.parsed_document && !!this.parsed_job_id;
    },
  },
  methods: {
    go_to_job_profile(entity_type_id, mode = "preview") {
      this.$router.push({ name: "view_job_profile", params: { id: entity_type_id }, query: { mode } });
    },
    setup_assign_modal_events() {
      const modal_el = $("#assign_sub_entity_modal");
      if (!modal_el.length) return;
      modal_el.on("shown.bs.modal", () => this.init_assign_table());
      modal_el.on("hidden.bs.modal", () => this.destroy_assign_table());
    },
    setup_create_modal_events() {
      const create_modal = $("#create_trust_type");
      if (!create_modal.length) return;
      create_modal.on("hidden.bs.modal", () => this.reset_create_modal_state());
    },
    bind_body_class(modal_id, body_class, on_hidden) {
      const modal = $(`#${modal_id}`);
      if (!modal.length) return;
      modal.on("show.bs.modal shown.bs.modal", () => document.body.classList.add(body_class));
      modal.on("hidden.bs.modal", () => {
        document.body.classList.remove(body_class);
        if (typeof on_hidden === "function") on_hidden();
      });
    },
    setup_create_advert_modal_events() {
      this.bind_body_class("create_advert_modal", "dwypd-create-advert-modal-open");
    },
    setup_edit_advert_modal_events() {
      this.bind_body_class("edit_advert_modal", "dwypd-edit-advert-modal-open");
    },
    setup_view_profile_modal_events() {
      this.bind_body_class("view_job_profile_modal", "dwypd-side-drawer-open", () => {
        this.view_job_profile_drawer_expanded = false;
      });
    },
    set_view_job_profile_drawer_expanded(expanded) {
      this.view_job_profile_drawer_expanded = !!expanded;
    },
    setup_edit_profile_modal_events() {
      this.bind_body_class("edit_trust_type", "dwypd-edit-modal-open");
    },
    go_to_create_stage(stage_name) {
      this.create_modal_stage = stage_name;
      if (stage_name === "create") {
        this.reset_create_modal_state();
      }
    },
    update_extraction_progress(step_index, status) {
      const step = Reflect.get(this.extraction_progress_steps, step_index);
      if (!step) return;
      step.status = status;
      this.extraction_current_step = step_index;
    },
    async simulate_extraction_progress() {
      const steps = [
        { delay: 300, status: "done" },
        { delay: 600, status: "done" },
        { delay: 1000, status: "running" },
        { delay: 1500, status: "done" },
        { delay: 2000, status: "running" },
        { delay: 2800, status: "done" },
      ];
      for (let i = 0; i < steps.length; i += 1) {
        if (!this.is_extracting_ai) return;
        const step = Reflect.get(steps, i);
        await new Promise((resolve) => setTimeout(resolve, step.delay));
        if (!this.is_extracting_ai) return;
        this.update_extraction_progress(i, step.status);
      }
    },
    mark_extraction_progress_complete() {
      this.extraction_progress_steps = this.extraction_progress_steps.map((step) => ({ ...step, status: "done" }));
      this.extraction_current_step = Math.max(this.extraction_progress_steps.length - 1, 0);
    },
    on_job_file_selected(event) {
      const files = event.target.files || [];
      this.job_profile_file = files.length > 0 ? get_first_selected_file(files) : null;
    },
    set_active_create_section(index) {
      if (index >= 0 && index < this.create_job_sections.length) {
        this.create_active_section_index = index;
      }
    },
    add_create_section() {
      const title = this.create_new_section_title.trim() || `Section ${this.create_job_sections.length + 1}`;
      this.create_job_sections.push({
        title,
        descriptions: [""],
        show_on_advert: true,
        use_columns: false,
        headers: [],
        rows: [],
      });
      this.create_active_section_index = this.create_job_sections.length - 1;
      this.create_new_section_title = "";
      this.has_extraction_preview = true;
    },
    remove_create_section(index) {
      if (this.create_job_sections.length <= 1) {
        this.show_warning("Cannot remove the last section");
        return;
      }
      this.create_job_sections.splice(index, 1);
      if (this.create_active_section_index >= this.create_job_sections.length) {
        this.create_active_section_index = this.create_job_sections.length - 1;
      }
      if (this.create_job_sections.length === 0) {
        this.has_extraction_preview = false;
      }
    },
    add_create_description_entry(section_index) {
      const section = Reflect.get(this.create_job_sections, section_index);
      if (!section) return;
      if (!Array.isArray(section.descriptions)) section.descriptions = [];
      section.descriptions.push("");
    },
    remove_create_description_entry(section_index, desc_idx) {
      const section = Reflect.get(this.create_job_sections, section_index);
      if (!section || !Array.isArray(section.descriptions)) return;
      if (section.descriptions.length <= 1) {
        this.show_warning("Section must have at least one description");
        return;
      }
      section.descriptions.splice(desc_idx, 1);
    },
    reset_create_modal_state() {
      this.trust_type_name = "";
      this.trust_type_description = "";
      this.job_profile_file = null;
      this.create_entity_type_id = null;
      this.is_extracting_ai = false;
      this.has_extraction_preview = false;
      this.create_job_title = "";
      this.create_job_description = "";
      this.create_job_requirements = "";
      this.create_job_key_duties = "";
      this.create_job_sections = [];
      this.create_new_section_title = "";
      this.create_active_section_index = 0;
      this.create_modal_stage = "create";
      this.extraction_current_step = 0;
      this.extraction_progress_steps.forEach((step) => { step.status = "wait"; });
    },
    set_active_tab(tab) {
      this.active_tab = tab;
      sessionStorage.setItem("active_tab", tab);
    },
  },
};
